import { Navigate } from 'react-router-dom';
import { useAccount } from 'wagmi';

// Hooks
import { useAppSelector } from '../../../store';

const AdminRoute = ({ children }) => {
  const isAdmin = useAppSelector(s => s.main.isAdmin);
  const isReferralManager = useAppSelector(s => s.main.isReferralManager);
  const { isConnected } = useAccount();

  return (isAdmin || isReferralManager) && isConnected ? children : <Navigate to="/" />;
};

export default AdminRoute;
